import { stripDigits } from "@repo/core/utils/mask.utils";

export const ADDITIONAL_PHONE_EQUALS_PRIMARY_MESSAGE =
  "O telefone adicional não pode ser igual ao telefone principal.";

export const joinPhoneDigits = (
  ddd?: string | null,
  number?: string | null
): string => `${stripDigits(ddd)}${stripDigits(number)}`;

export const areNormalizedPhonesEqual = (
  left?: string | null,
  right?: string | null
): boolean => {
  const leftDigits = stripDigits(left);
  const rightDigits = stripDigits(right);

  if (!leftDigits || !rightDigits) {
    return false;
  }

  return leftDigits === rightDigits;
};

export const splitPhoneDigits = (
  raw?: string | null
): { ddd: string; number: string } => {
  const digits = stripDigits(raw);
  if (digits.length < 10) {
    return { ddd: "", number: "" };
  }

  return { ddd: digits.slice(0, 2), number: digits.slice(2) };
};

export const isCompleteAdditionalPhone = (raw?: string | null): boolean => {
  const digits = stripDigits(raw);
  return digits.length === 10 || digits.length === 11;
};
